import {ISvgColours, IconColour} from 'Shared/backend/IconColour'

/*
	The VOS mark with the laptop and rolled poster, traced from the artwork with potrace. The line
	work is hand drawn, so the wobble is deliberate - it is the logo, not trace noise.

	The transform is potrace's own: it works in tenths of a unit with the y axis flipped, so the path
	data is left as traced rather than being rewritten to the viewBox.
*/
export function VosLogoLaptop(props:ISvgColours)
{
	return (
		<svg class={props.class} viewBox='0 0 1000 501' xmlns='http://www.w3.org/2000/svg'
			style={`fill:${props.fill ?? IconColour.text}; stroke:${props.stroke ?? 'none'};`}
		>
			<g transform='translate(0,501) scale(0.100000,-0.100000)'>
				<path d='M1470 4436 c-134 -42 -240 -87 -309 -131 -151 -95 -191 -122 -224
-154 -72 -68 -80 -109 -32 -161 13 -14 37 -54 53 -90 16 -36 52 -103 81 -149
28 -46 51 -92 51 -102 0 -10 5 -21 10 -24 6 -4 21 -28 34 -53 34 -68 143 -268
170 -311 19 -31 41 -75 70 -141 8 -17 24 -44 49 -81 17 -25 16 -28 -3 -72 -11
-25 -48 -81 -83 -125 -34 -44 -79 -104 -100 -134 -21 -30 -47 -59 -57 -66 -18
-11 -219 -23 -643 -38 -156 -5 -190 -9 -194 -21 -4 -9 -1 -124 6 -257 6 -132
13 -286 15 -341 2 -55 8 -156 14 -225 17 -193 26 -561 14 -590 -16 -41 1 -66
58 -85 47 -16 165 -80 200 -110 8 -7 40 -25 70 -41 30 -16 75 -43 100 -60 25
-18 72 -46 105 -64 33 -18 83 -47 110 -65 28 -18 55 -34 60 -36 6 -2 54 -31
108 -64 127 -79 169 -103 187 -111 8 -4 28 -17 45 -28 16 -12 59 -36 94 -54
55 -28 72 -32 110 -28 25 4 246 13 491 22 245 9 558 20 695 25 138 5 258 9
268 9 9 0 26 0 37 0 11 0 30 1 43 2 217 15 650 24 692 14 40 -9 56 4 58 44 2
36 -1 39 -85 75 -21 9 -38 20 -38 24 0 5 -13 14 -29 19 -16 6 -48 24 -71 41
-24 17 -47 31 -53 31 -5 0 -32 18 -59 40 -28 22 -56 40 -63 40 -7 0 -48 23
-91 51 -67 44 -302 170 -423 228 -18 9 -68 34 -110 55 -42 22 -103 52 -136 68
-33 15 -76 36 -95 46 l-35 17 -6 95 c-4 52 -12 266 -18 475 -17 557 -28 808
-36 828 -4 10 -21 21 -37 24 -39 8 -49 31 -46 109 3 65 2 67 -32 95 -19 16
-40 29 -47 29 -17 0 -16 5 3 41 20 39 12 60 -44 133 -34 44 -47 72 -53 110
-10 59 -28 76 -82 76 -21 0 -47 4 -57 10 -19 10 -80 131 -80 159 0 9 -5 22
-11 28 -13 13 -35 64 -125 288 -36 88 -71 174 -79 190 -8 17 -21 47 -29 68 -8
21 -35 81 -59 135 -68 149 -80 181 -86 224 -6 44 -35 73 -81 82 -14 3 -83 -13
-160 -38z m103 -84 c-12 -9 -44 -30 -72 -47 -28 -16 -51 -33 -51 -37 0 -5 -7
-8 -17 -8 -9 0 -30 -11 -47 -24 -39 -29 -284 -135 -331 -143 -51 -8 -43 9 20
48 31 19 85 53 121 76 36 23 94 51 129 63 36 12 67 25 70 30 3 4 31 16 63 25
31 9 64 21 72 25 8 5 26 9 40 9 l25 0 -22 -17z m92 -112 c14 -27 25 -56 25
-63 0 -8 20 -54 44 -103 24 -49 53 -114 64 -144 40 -103 81 -205 111 -277 17
-40 45 -106 62 -145 16 -40 36 -89 44 -109 7 -19 25 -59 40 -88 26 -51 26 -54
8 -73 -10 -11 -49 -38 -87 -61 -68 -39 -104 -70 -133 -113 -19 -30 -1 -66 48
-93 21 -12 39 -25 39 -28 0 -2 -9 -16 -20 -30 -11 -14 -20 -38 -20 -54 0 -32
39 -60 108 -79 24 -6 42 -14 40 -18 -2 -4 -14 -29 -26 -56 -21 -46 -21 -50 -6
-67 9 -10 39 -29 65 -41 27 -12 49 -25 49 -29 0 -14 -39 -46 -93 -74 -29 -16
-74 -44 -100 -63 -57 -41 -51 -46 -127 98 -28 52 -64 117 -81 143 -34 56 -41
140 -17 207 44 126 88 309 88 372 0 64 -27 114 -67 124 -34 9 -93 -21 -109
-56 -79 -171 -107 -220 -125 -220 -4 0 -13 16 -19 36 -15 44 -28 70 -57 110
-13 18 -32 51 -43 75 -11 24 -33 67 -50 94 -16 28 -34 60 -40 73 -26 58 -32
70 -55 107 -71 118 -208 385 -201 392 3 3 44 16 92 30 99 28 270 111 391 190
44 29 85 53 91 53 5 0 15 7 22 15 7 8 14 15 16 15 2 0 15 -22 29 -50z m39
-1024 c-3 -17 -14 -58 -24 -91 -97 -315 -98 -396 -10 -567 7 -12 3 -18 -16
-22 -44 -11 -202 -180 -294 -314 -19 -28 -43 -54 -53 -57 -9 -4 -22 -16 -28
-27 -11 -20 -161 -198 -238 -283 -20 -22 -49 -48 -64 -58 -32 -21 -34 -41 -6
-61 34 -23 68 -4 152 87 105 113 290 327 390 451 68 84 142 157 165 163 32 8
90 -23 94 -50 6 -44 146 -87 179 -55 25 24 115 78 131 78 9 0 21 7 28 15 12
15 88 54 147 75 18 7 67 32 109 56 98 56 119 57 128 7 9 -57 7 -131 -3 -138
-6 -3 -6 -16 -1 -33 7 -22 20 -335 20 -487 0 -8 0 -23 1 -32 17 -458 18 -588
5 -601 -11 -12 -62 -15 -248 -18 -225 -4 -692 -18 -928 -30 -63 -3 -198 -7
-300 -9 -102 -3 -251 -10 -331 -16 -105 -9 -151 -9 -166 -1 -14 8 -23 8 -31 0
-18 -18 -20 0 -26 242 -3 124 -11 284 -17 355 -6 72 -16 257 -22 412 l-12 282
80 10 c80 10 295 24 348 23 39 -1 43 -1 135 5 69 4 82 2 82 -11 0 -8 -9 -20
-21 -26 -11 -6 -32 -30 -47 -53 -34 -53 -117 -160 -159 -207 -83 -92 -116
-147 -111 -188 2 -21 9 -28 29 -30 20 -2 37 10 87 67 34 38 62 72 62 76 0 8
23 37 104 132 26 32 66 84 87 115 21 31 61 82 89 114 27 31 69 84 93 116 23
33 72 99 110 146 37 48 86 123 109 167 23 44 45 82 50 83 4 2 8 9 8 14 0 6 20
44 45 84 25 40 50 88 56 106 21 65 20 64 30 39 6 -14 7 -39 3 -55z m527 -33
c16 -44 8 -64 -36 -80 -115 -42 -265 -72 -265 -52 0 5 29 23 64 39 35 16 77
40 94 54 28 24 107 65 125 66 4 0 12 -12 18 -27z m94 -206 c-19 -41 -73 -72
-143 -83 -23 -4 -45 -11 -48 -15 -3 -5 -32 -9 -65 -9 -111 0 -76 28 193 155
40 20 44 20 62 4 17 -16 17 -18 1 -52z m86 -139 c15 -28 -41 -78 -128 -112
-37 -16 -83 -34 -101 -42 -41 -17 -85 -18 -80 -2 7 21 90 76 176 117 45 22 85
47 88 55 7 18 31 10 45 -16z m-105 -204 c-22 -16 -46 -19 -46 -5 0 10 52 31
60 24 3 -3 -4 -11 -14 -19z m386 -1481 c21 -3 42 -11 49 -19 6 -8 17 -14 25
-14 7 0 24 -11 37 -24 14 -14 44 -30 68 -37 24 -7 51 -18 59 -24 29 -23 125
-73 153 -79 15 -4 46 -20 70 -37 45 -33 169 -106 253 -148 28 -14 65 -38 83
-53 18 -16 38 -28 45 -28 6 0 25 -12 42 -27 17 -16 40 -33 50 -39 11 -7 16
-15 13 -18 -4 -4 -133 -11 -287 -16 -155 -4 -285 -11 -290 -14 -4 -2 -163 -7
-353 -11 -189 -3 -370 -10 -401 -17 -44 -8 -61 -8 -72 1 -10 8 -16 9 -21 1 -4
-6 -55 -10 -128 -11 -67 0 -174 -4 -237 -8 -65 -4 -127 -3 -143 2 -19 7 -32 6
-40 -2 -14 -14 -42 -14 -65 -1 -9 6 -38 19 -64 30 -27 10 -48 24 -48 29 0 10
-96 66 -102 60 -2 -2 -22 10 -43 27 -22 17 -72 48 -112 68 -39 21 -77 44 -84
52 -7 8 -46 32 -88 52 -81 39 -103 52 -194 120 -32 24 -78 50 -102 59 -24 8
-46 21 -49 30 -4 9 -5 16 -4 17 2 1 13 7 26 14 18 10 27 10 37 2 9 -8 20 -8
32 -2 10 5 62 8 115 6 54 -2 100 0 102 5 4 7 57 6 82 0 5 -2 29 0 54 4 25 4
101 8 170 8 69 1 147 5 174 10 33 6 53 6 62 -2 10 -8 26 -8 59 0 26 6 50 9 54
7 15 -10 161 -9 173 1 7 5 109 10 227 12 118 2 246 6 285 10 39 3 82 3 96 -2
17 -6 44 -4 80 6 30 8 69 13 85 11 17 -3 47 -8 67 -11z
M5720 4410 c-362 -45 -665 -297 -792 -659 -50 -144 -60 -201 -65
-397 -6 -212 3 -302 42 -439 33 -115 118 -292 179 -372 233 -307 659 -441
1075 -337 308 77 558 317 666 638 123 367 82 819 -102 1115 -144 230 -356 384
-604 436 -91 20 -299 27 -399 15z m300 -121 c282 -35 546 -255 659 -549 64
-166 74 -227 74 -445 0 -185 -2 -207 -26 -298 -96 -354 -300 -583 -601 -676
-148 -46 -410 -37 -552 18 -362 141 -584 504 -584 956 0 495 268 884 679 985
87 21 226 25 351 9z
M8370 4413 c-104 -11 -202 -38 -288 -79 -261 -126 -371 -363 -297
-642 27 -105 96 -186 215 -256 90 -53 184 -86 360 -129 472 -113 527 -128 608
-167 99 -47 181 -121 218 -196 32 -66 43 -193 24 -275 -41 -175 -188 -307
-397 -356 -118 -27 -377 -25 -496 5 -181 45 -310 128 -390 249 -57 88 -73 131
-87 234 -19 141 -11 129 -85 129 l-65 0 6 -62 c21 -219 84 -361 215 -483 137
-127 329 -195 600 -211 198 -11 373 19 519 88 67 32 101 57 161 117 103 103
147 191 159 318 18 197 -20 321 -132 433 -111 110 -246 162 -654 255 -275 63
-337 81 -429 125 -102 49 -166 105 -202 178 -26 52 -28 67 -28 167 0 98 3 116
26 166 53 113 159 198 303 246 75 24 94 26 256 27 197 0 252 -10 378 -70 155
-74 255 -208 290 -387 l17 -87 68 0 68 0 -7 48 c-44 306 -187 480 -469 571
-132 43 -313 60 -465 44z
M2497 4363 c-5 -8 49 -154 523 -1431 l265 -712 79 2 c58 2 81 7 87
18 13 22 781 2081 787 2109 5 23 4 23 -59 16 -35 -4 -67 -10 -71 -14 -3 -3
-85 -222 -181 -486 -314 -861 -549 -1500 -552 -1503 -12 -12 -113 256 -482
1277 -140 388 -258 709 -261 712 -11 11 -129 21 -135 12z
M5925 1827 c-9 -56 -2 -443 8 -453 4 -4 10 -4 15 0 9 9 16 418 7 463
-8 46 -23 41 -30 -10z
M6034 1857 c-9 -25 0 -62 16 -62 10 0 15 10 15 34 0 36 -21 54 -31
28z
M8274 1857 c-9 -25 0 -62 16 -62 10 0 15 10 15 34 0 36 -21 54 -31
28z
M4014 1724 c-21 -7 -46 -23 -55 -36 l-17 -22 -4 29 c-4 41 -26 43
-33 2 -9 -46 -2 -313 8 -323 17 -18 27 25 27 124 0 122 18 169 74 196 47 22
80 20 113 -8 27 -23 27 -26 33 -164 3 -77 8 -143 12 -147 4 -4 12 -4 19 0 15
10 5 244 -12 294 -18 52 -97 79 -165 55z
M5291 1730 c-79 -19 -124 -82 -125 -174 -1 -77 32 -149 77 -173 42
-21 124 -21 164 0 49 26 77 87 76 167 0 40 -6 77 -16 96 -20 39 -72 84 -97 84
-10 0 -24 2 -32 4 -7 2 -28 0 -47 -4z m97 -40 c38 -24 72 -89 72 -140 0 -42
-29 -108 -60 -135 -31 -28 -119 -28 -150 0 -54 49 -71 156 -36 223 35 67 112
90 174 52z
M7136 1730 c-44 -14 -76 -49 -76 -85 0 -58 36 -84 158 -115 84 -21
110 -83 50 -120 -66 -40 -158 -17 -184 46 -14 33 -28 42 -38 26 -2 -4 3 -26
13 -48 23 -50 63 -69 142 -67 95 2 143 54 119 127 -12 36 -21 42 -145 82 -60
19 -85 40 -85 69 0 79 155 83 195 5 13 -24 20 -29 28 -21 15 15 -7 56 -43 82
-31 22 -95 31 -134 19z
M8485 1725 c-50 -18 -90 -64 -104 -120 -14 -54 -14 -70 0 -118 31
-114 164 -162 249 -90 39 32 65 82 52 95 -7 7 -19 -3 -36 -31 -94 -148 -285
-39 -236 134 14 49 60 102 98 112 41 10 103 -17 130 -57 28 -42 42 -49 42 -21
0 31 -57 89 -98 101 -46 12 -48 12 -97 -5z
M9186 1730 c-44 -14 -76 -49 -76 -85 0 -58 36 -84 158 -115 84 -21
110 -83 50 -120 -66 -40 -158 -17 -184 46 -14 33 -28 42 -38 26 -2 -4 3 -26
13 -48 23 -50 63 -69 142 -67 95 2 143 54 119 127 -12 36 -21 42 -145 82 -60
19 -85 40 -85 69 0 79 155 83 195 5 13 -24 20 -29 28 -21 15 15 -7 56 -43 82
-31 22 -95 31 -134 19z
M3207 1723 c-6 -9 54 -165 102 -270 36 -77 51 -87 75 -50 24 37 117
297 114 315 -6 24 -38 -41 -88 -174 -22 -60 -44 -112 -49 -117 -4 -4 -25 37
-46 90 -39 100 -92 213 -100 213 -2 0 -6 -3 -8 -7z
M3596 1700 c-42 -37 -58 -81 -60 -164 -1 -73 22 -120 74 -150 47 -28
130 -27 167 0 35 26 66 78 61 101 -3 14 -11 8 -33 -25 -44 -67 -107 -89 -169
-60 -24 11 -76 96 -76 125 0 10 33 13 146 13 l146 0 -7 48 c-14 96 -66 142
-159 142 -47 0 -60 -4 -90 -30z m156 -11 c25 -14 58 -68 58 -97 0 -22 -1 -23
-120 -21 -119 2 -120 2 -120 25 0 26 53 92 84 104 24 9 69 4 98 -11z
M4266 1714 c-9 -23 -7 -150 4 -224 8 -56 14 -70 45 -98 35 -32 39
-33 88 -27 31 4 65 17 84 31 l32 24 3 -22 c5 -35 26 -32 33 5 9 46 2 313 -8
323 -17 17 -27 -25 -27 -116 0 -156 -27 -208 -112 -217 -37 -4 -49 -1 -76 22
l-32 27 0 113 c0 116 -7 175 -20 175 -4 0 -11 -7 -14 -16z
M4679 1703 c-43 -37 -59 -80 -59 -160 0 -121 46 -176 149 -177 46 -1
66 4 88 20 35 26 66 78 61 101 -3 14 -11 8 -33 -25 -44 -67 -107 -89 -169 -60
-24 11 -76 96 -76 125 0 10 33 13 146 13 l146 0 -7 48 c-14 95 -66 142 -158
142 -46 0 -61 -5 -88 -27z m136 -7 c37 -16 75 -68 75 -103 0 -23 -2 -23 -120
-23 -118 0 -120 0 -120 23 0 45 69 117 113 117 10 0 33 -6 52 -14z
M5555 1697 c-9 -46 -2 -313 8 -323 17 -18 27 25 27 124 0 122 18 169
74 196 47 22 80 20 112 -8 27 -23 28 -26 34 -164 3 -78 10 -145 14 -149 19
-19 27 29 22 139 -8 175 -33 218 -132 218 -38 0 -61 -6 -87 -24 -36 -24 -36
-24 -39 -4 -5 35 -26 32 -33 -5z
M6035 1697 c-9 -44 -2 -313 8 -323 17 -17 22 15 25 149 4 144 -2 207
-18 207 -5 0 -12 -15 -15 -33z
M6145 1697 c-9 -46 -2 -313 8 -323 17 -18 27 25 27 124 0 122 18 169
74 196 47 22 80 20 112 -8 27 -23 28 -26 34 -164 3 -78 10 -145 14 -149 19
-19 27 29 22 139 -7 173 -34 218 -129 218 -53 0 -100 -20 -112 -47 -7 -15 -9
-13 -14 11 -9 42 -29 44 -36 3z
M6559 1703 c-43 -37 -59 -80 -59 -160 0 -121 46 -176 149 -177 46 -1
66 4 88 20 35 26 66 78 61 101 -3 14 -11 8 -33 -25 -44 -67 -107 -89 -169 -60
-24 11 -76 96 -76 125 0 10 33 13 146 13 l146 0 -7 48 c-14 95 -66 142 -158
142 -46 0 -61 -5 -88 -27z m141 -8 c39 -20 70 -62 70 -96 l0 -29 -120 0 -120
0 0 26 c0 18 14 41 44 70 47 48 76 55 126 29z
M7449 1703 c-43 -37 -59 -80 -59 -160 0 -121 46 -176 149 -177 46 -1
66 4 88 20 35 26 66 78 61 101 -3 14 -11 8 -33 -25 -44 -67 -107 -89 -169 -60
-24 11 -76 96 -76 125 0 10 33 13 146 13 l146 0 -7 48 c-14 95 -66 142 -158
142 -46 0 -61 -5 -88 -27z m154 -15 c24 -13 57 -68 57 -96 0 -23 -1 -23 -115
-21 -64 1 -118 6 -121 11 -4 6 4 29 16 53 35 68 97 88 163 53z
M7755 1697 c-9 -46 -2 -313 8 -323 17 -17 27 25 27 119 0 62 5 110
14 132 15 35 67 75 98 75 19 0 43 -42 79 -132 42 -108 82 -188 95 -188 8 0 20
10 28 23 24 37 117 297 114 315 -6 24 -38 -41 -88 -174 -22 -60 -44 -112 -49
-117 -4 -4 -25 37 -46 90 -45 115 -83 195 -99 206 -18 12 -79 -3 -113 -29
l-32 -24 -3 27 c-5 39 -26 40 -33 0z
M8275 1697 c-9 -44 -2 -313 8 -323 17 -17 22 15 25 149 4 144 -2 207
-18 207 -5 0 -12 -15 -15 -33z
M8796 1700 c-42 -37 -58 -81 -60 -164 -1 -73 22 -120 74 -150 47 -28
130 -27 167 0 35 26 66 78 61 101 -3 14 -11 8 -33 -25 -44 -67 -107 -89 -169
-60 -24 11 -76 96 -76 125 0 10 33 13 146 13 l146 0 -7 48 c-14 96 -66 142
-159 142 -47 0 -60 -4 -90 -30z m144 -5 c39 -20 70 -62 70 -96 l0 -29 -120 0
-120 0 0 28 c0 32 24 65 65 92 36 24 66 25 105 5z' />
			</g>
		</svg>
	);
}
